import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGnusocialComponent } from './simple-icons-gnusocial.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGnusocialComponent ],
    exports:      [ SimpleIconsGnusocialComponent ],
    bootstrap:    []
})
export class SimpleIconsGnusocialModule {}
